import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Aggravating Factors", -1)
const _hoisted_4 = { class: "w-full relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Mitigating Factors", -1)
const _hoisted_6 = { class: "w-full relative" }

import { ref, watch } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FactorsTab',
  props: {
    aggravatingFactors: {
        type: Object,
        required: true
    },
    mitigatingFactors: {
        type: Object,
        required: true
    },
    form: {
        type: Object,
        required: true
    },
    isView: {
        type: Boolean,
        default: false
    }
},
  emits: ['update:form'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const form = ref(props.form)

const updateAggravatingIds = (id: number):void => {
    if (!form.value.aggravatingFactors.includes(id)) {
        form.value.aggravatingFactors.push(id)
    } else {
        form.value.aggravatingFactors.splice(form.value.aggravatingFactors.indexOf(id), 1)
    }
}

const updateMitigatingIds = (id: number):void => {
    if (!form.value.mitigatingFactors.includes(id)) {
        form.value.mitigatingFactors.push(id)
    } else {
        form.value.mitigatingFactors.splice(form.value.mitigatingFactors.indexOf(id), 1)
    }
}

watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["lg:col-span-6 col-span-12 border rounded-2xl border-neutral-100 flex flex-col min-h-[250px] space-y-5 md:p-6 p-4", __props.isView ? 'cursor-not-allowed' : ''])
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col space-y-3", __props.isView ? 'pointer-events-none' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.aggravatingFactors, (item, index) => {
              return (_openBlock(), _createBlock(CheckboxInput, {
                key: index,
                checked: form.value.aggravatingFactors.includes(item.id),
                id: `aggravating-${item.id}`,
                name: `aggravating-${item.id}`,
                label: item.label,
                "onUpdate:modelValue": (value) => updateAggravatingIds(item.id),
                readonly: __props.isView
              }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue", "readonly"]))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full relative", __props.isView ? 'pointer-events-none' : ''])
        }, [
          _createVNode(TextInput, {
            label: "Others, describe below",
            placeholder: "Describe here",
            name: "others_aggrevating_factors",
            id: "others_aggrevating_factors",
            textAreaRows: 5,
            textarea: "",
            modelValue: form.value.other_aggravating,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.other_aggravating) = $event)),
            disabled: __props.isView
          }, null, 8, ["modelValue", "disabled"])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["lg:col-span-6 col-span-12 border rounded-2xl border-neutral-100 flex flex-col min-h-[250px] space-y-5 md:p-6 p-4", __props.isView ? 'cursor-not-allowed' : ''])
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col space-y-3", __props.isView ? 'pointer-events-none' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.mitigatingFactors, (item, index) => {
              return (_openBlock(), _createBlock(CheckboxInput, {
                key: index,
                checked: form.value.mitigatingFactors.includes(item.id),
                id: `mitigating-${item.id}`,
                name: `mitigating-${item.id}`,
                label: item.label,
                "onUpdate:modelValue": (value) => updateMitigatingIds(item.id),
                readonly: __props.isView
              }, null, 8, ["checked", "id", "name", "label", "onUpdate:modelValue", "readonly"]))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full relative", __props.isView ? 'pointer-events-none' : ''])
        }, [
          _createVNode(TextInput, {
            label: "Others, describe below",
            placeholder: "Describe here",
            name: "others_mitigating_factors",
            id: "others_mitigating_factors",
            textAreaRows: 5,
            textarea: "",
            modelValue: form.value.other_mitigating,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.other_mitigating) = $event)),
            disabled: __props.isView
          }, null, 8, ["modelValue", "disabled"])
        ], 2)
      ], 2)
    ])
  ]))
}
}

})